export default "__VITE_ASSET__BV94sd9p__"